module.exports = __webpack_public_path__ + "img/1.c95de75e.png";